import React from 'react';
export function FinalCTA() {
  return <section className="mb-16" data-id="element-126">
      <div className="bg-gradient-to-br from-[#FFB88C] to-[#FFE5D9] border border-[#FFB88C]/50 rounded-lg p-8 md:p-10 text-center shadow-md" data-id="element-127">
        <p className="text-xl font-bold text-[#1B2951] mb-6 font-['Poppins']" data-id="element-128">
          You don't have to wait 90 days anymore.
        </p>
        <p className="text-lg text-[#1B2951] mb-6 font-['Inter']" data-id="element-129">
          You don't have to accept 'good enough.'
          <br data-id="element-130" />
          <br data-id="element-131" />
          You deserve better. Your skin deserves better.
          <br data-id="element-132" />
          <br data-id="element-133" />
          And now, finally, better is here.
        </p>
        <p className="text-lg text-[#1B2951] font-medium mb-8 font-['Poppins']" data-id="element-134">
          Welcome to the future of collagen.
        </p>
        <div className="mb-8" data-id="element-135">
          <p className="text-[#2C3E50] mb-2 font-['Inter']" data-id="element-136">
            With warm regards,
          </p>
          <div className="flex justify-center" data-id="element-137">
            <div className="h-16 w-40 bg-white/50 rounded-lg flex items-center justify-center text-[#1B2951] font-bold text-lg font-['Playfair_Display']" data-id="element-138">
              Nihaal Mariwala
            </div>
          </div>
          <p className="text-[#1B2951] font-medium font-['Poppins']" data-id="element-139">
            Nihaal Mariwala
          </p>
          <p className="text-[#2C3E50] font-['Inter']" data-id="element-140">Founder, Setu</p>
        </div>
        <button className="bg-gradient-to-r from-[#FF8E72] to-[#FFB88C] hover:from-[#FF8E72] hover:to-[#FF8E72] text-white font-bold py-4 px-8 rounded-lg text-xl mb-4 transition duration-300 ease-in-out transform hover:scale-105 shadow-md w-full md:w-auto md:px-12 font-['Poppins']" data-id="element-141">
          GET YOUR UPGRADED COLLAGEN NOW - 25% OFF
        </button>
        <p className="text-[#2C3E50] text-sm font-['Inter']" data-id="element-142">
          60-day money-back guarantee • Free shipping
        </p>
      </div>
    </section>;
}